<template>
  <div>
    <el-button
      icon="el-icon-plus"
      type="primary"
      size="small"
      @click="editItem()"
      v-if="!addDisabled"
      v-permission="
        template.category == 1 ? Auth.productNew : Auth.instrumentNew
      "
      >添加{{ template.name }}</el-button
    >
    <!-- <file-button
      v-permission="
        template.category == 1
          ? Auth.productAssembleIE
          : Auth.instrumentAssembleIE
      "
      obj="product_assemble"
      :filter="filter"
      :templateId="template.id"
      :exportButton="false"
      :name="`导入${template.name}装配表`"
      :templateLabel="`下载${template.name}装配模板表`"
      class="ml-30"
      @importCallback="assembleImportCallback"
    ></file-button> -->

    <file-button
      v-permission="template.category == 1 ? Auth.productIE : Auth.instrumentIE"
      obj="product"
      :filter="filter"
      :templateId="template.id"
      :groupName="filter.group_name"
      @importCallback="importCallback"
      style="margin-bottom: 10px"
    ></file-button>
    <el-table
      :data="items"
      border
      size="small"
      class="mt-10"
      v-loading="loading"
      @selection-change="handleSelectionChange"
      ref="table"
    >
      <el-table-column
        type="selection"
        align="center"
        width="50"
        v-if="multiSelecting && total > 0"
      >
      </el-table-column>
      <el-table-column
        fixed="left"
        align="center"
        label="编号"
        prop="code"
        min-width="145"
      ></el-table-column>
      <el-table-column
        align="center"
        label="发往基地"
        prop="base.name"
        min-width="120"
        v-if="template.category == 1"
      >
      </el-table-column>
      <el-table-column
        align="center"
        label="库存基地"
        min-width="180px"
        v-if="template.category == 2"
      >
        <template slot-scope="scope">
          <div>
            {{ scope.row.base.name || '无' }}
          </div>
          <div class="text-danger" v-if="scope.row.receive_base_id">
            {{ `（待${scope.row.receive_base.name}接收）` }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="发往钻井"
        min-width="135px"
        v-if="template.category == 2"
      >
        <template slot-scope="scope">
          <div>
            {{ scope.row.drill_well.well_number || '无' }}
          </div>
          <div class="text-danger" v-if="scope.row.receive_well_id">
            {{ `（待${scope.row.receive_well.well_number}接收）` }}
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="使用次数" prop="used_count">
      </el-table-column>
      <el-table-column
        align="center"
        label="总工作时长"
        prop="total_man_hour"
        min-width="90"
      >
      </el-table-column>
      <el-table-column
        align="center"
        label="最近维修后工作时长/寿命天数"
        prop="current_man_hour"
        min-width="190"
      >
        <template slot-scope="scope">
          <template v-if="scope.row.last_repair_date">
            <span
              :class="{
                'text-danger':
                  scope.row.current_man_hour &&
                  [2, 3].includes(scope.row.lifewarning_type),
              }"
              >{{ scope.row.current_man_hour }}</span
            >
            /
            <span
              :class="{
                'text-danger':
                  scope.row.current_life_count &&
                  [1, 3].includes(scope.row.lifewarning_type),
              }"
              >{{ scope.row.current_life_count }}</span
            >
          </template>
          <template v-else>无维修日期</template>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        :label="param.label"
        :prop="param.key"
        v-for="param in template.custom_params"
        :key="param.key + param.label"
        :min-width="labelWidth(param.label)"
      >
        <template slot-scope="scope">
          {{
            scope.row.custom_params.filter((item) => item.label == param.label)
              .length > 0
              ? scope.row.custom_params.filter(
                  (item) => item.label == param.label,
                )[0].value
              : '-'
          }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="状态">
        <template slot-scope="scope">
          <ItemStatus :status="scope.row.status" model="product"></ItemStatus>
        </template>
      </el-table-column>
      <el-table-column align="center" label="装配进度">
        <template slot-scope="scope"
          >{{ scope.row.items.filter((item) => item.status == 2).length }} /
          {{ scope.row.items.length }}</template
        >
      </el-table-column>
      <!-- <el-table-column align="center" label="备注" prop="remark">
      </el-table-column> -->
      <el-table-column
        align="center"
        label="组装基地"
        prop="install_base.name"
        min-width="120"
      >
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        min-width="170"
        fixed="right"
      >
        <template slot-scope="scope">
          <div
            v-if="
              template.category == 2 &&
              scope.row.status == 2 &&
              $store.state.userInfo.base_id
            "
            v-permission="Auth.instrumentStockManage"
          >
            <template
              v-if="
                !scope.row.receive_base_id &&
                !scope.row.drill_well_id &&
                !scope.row.receive_well_id &&
                scope.row.base_id == $store.state.userInfo.base_id
              "
            >
              <el-link
                type="primary"
                class="font-12 ml-5"
                :underline="false"
                @click="itemStockOut(scope.row, scope.$index)"
                >出库{{
              }}</el-link>
              <el-link
                type="primary"
                class="font-12 ml-5"
                :underline="false"
                @click="itemSendToWell(scope.row, scope.$index)"
                >发往钻井</el-link
              >
            </template>
            <el-popconfirm
              v-if="
                scope.row.base_id == $store.state.userInfo.base_id &&
                ((scope.row.receive_base_id && !scope.row.receive_well_id) ||
                  (scope.row.receive_well_id &&
                    scope.row.receive_well_id == scope.row.drill_well_id))
              "
              title="确认撤回该成品吗？"
              @confirm="itemStockRecall(scope.row, scope.$index)"
            >
              <el-link
                slot="reference"
                type="danger"
                class="font-12 ml-5"
                :underline="false"
                >撤回</el-link
              >
            </el-popconfirm>
            <el-link
              v-if="scope.row.receive_base_id == $store.state.userInfo.base_id"
              type="danger"
              class="font-12 ml-5"
              :underline="false"
              @click="itemStockReject(scope.row, scope.$index)"
              >拒收</el-link
            >
            <el-popconfirm
              v-if="
                !scope.row.base_id ||
                (scope.row.receive_base_id == $store.state.userInfo.base_id &&
                  scope.row.drill_well_id == 0)
              "
              title="确认入库该成品吗？"
              @confirm="itemStockIn(scope.row, scope.$index)"
            >
              <el-link
                slot="reference"
                type="danger"
                class="font-12 ml-5"
                :underline="false"
                >确认入库</el-link
              >
            </el-popconfirm>
            <el-popconfirm
              v-if="
                scope.row.receive_base_id == $store.state.userInfo.base_id &&
                scope.row.drill_well_id > 0
              "
              title="确认该成品已从钻井返回吗？"
              @confirm="itemReceiveConfirm(scope.row, scope.$index)"
            >
              <el-link
                slot="reference"
                type="danger"
                class="font-12 ml-5"
                :underline="false"
                >确认接收</el-link
              >
            </el-popconfirm>
          </div>
          <template v-if="[2, 3].includes(scope.row.status)">
            <el-link
              @click="handleScrap(scope.row, scope.$index, 4)"
              v-permission="
                template.category == 1
                  ? Auth.productScrap
                  : Auth.instrumentScrap
              "
              type="danger"
              class="font-12 ml-5"
              :underline="false"
              >报废</el-link
            >
            <el-link
              @click="handleScrap(scope.row, scope.$index, 5)"
              v-permission="
                template.category == 1 ? Auth.productLost : Auth.instrumentLost
              "
              type="danger"
              class="font-12 ml-5"
              :underline="false"
              >灭失</el-link
            >
          </template>
          <el-popconfirm
            title="确认删除该成品吗？"
            @confirm="hanldeDelte(scope.row, scope.$index)"
          >
            <el-link
              slot="reference"
              v-permission="
                template.category == 1
                  ? Auth.productDelete
                  : Auth.instrumentDelete
              "
              type="danger"
              class="font-12 ml-5"
              :underline="false"
              >删除</el-link
            >
          </el-popconfirm>
          <el-link
            type="primary"
            class="font-12 ml-5"
            :underline="false"
            @click="editItem(scope.row, scope.$index)"
            v-permission="
              template.category == 1 ? Auth.productEdit : Auth.instrumentEdit
            "
            >编辑</el-link
          >
          <el-link
            type="primary"
            class="font-12 ml-5"
            :underline="false"
            v-permission="
              template.category == 1
                ? Auth.productDetail
                : Auth.instrumentDetail
            "
            @click="
              $router.push(
                `/${template.category == 1 ? 'products' : 'instruments'}/${
                  scope.row.id
                }`,
              )
            "
            >详情</el-link
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="table-footer">
      <div
        v-if="total > 0 && canTransfer"
        v-permission="
          template.category == 1
            ? Auth.productTransferGroup
            : Auth.instrumentTransferGroup
        "
      >
        <span class="pointer mr-10" @click="multiSelecting = !multiSelecting"
          >{{ multiSelecting ? '取消' : '' }}勾选</span
        >
        <el-button type="primary" size="small" @click="batchTransfer"
          >批量转移分组</el-button
        >
      </div>
      <el-pagination
        :page-sizes="[10, 20, 50, 100]"
        :page-size="filter.size"
        :current-page.sync="filter.page"
        @size-change="handleSizeChange"
        @current-change="getData"
        layout="total,sizes, prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>
    <ItemFormer
      :model="model"
      :show.sync="formerVisible"
      @updated="updatedCallback"
    ></ItemFormer>

    <StockoutFormer
      :model="model"
      :show.sync="stockoutFormerVisible"
      @updated="updatedCallback"
    ></StockoutFormer>
    <WellFormer
      :model="model"
      :show.sync="wellFormerVisible"
      @updated="updatedCallback"
    ></WellFormer>
    <ScrapFormer
      :model="model"
      :show.sync="scrapFormerVisible"
      @callback="scrapCallback"
    ></ScrapFormer>
    <TransferFormer
      :model="model"
      :show.sync="transferFormerVisible"
      @callback="getData"
    ></TransferFormer>
  </div>
</template>

<script>
import {
  productList,
  productDelete,
  productStockIn,
  productReceiveComfirm,
  productScrap,
  productRecall,
  productReject,
} from '@/service/getData'
import ItemFormer from './former'
import StockoutFormer from './stockout_former'
import WellFormer from './well_former'
import ScrapFormer from '../../components/ScrapFormer.vue'
import TransferFormer from './transfer_former.vue'

export default {
  components: {
    ItemFormer,
    StockoutFormer,
    WellFormer,
    ScrapFormer,
    TransferFormer,
  },
  props: {
    template: Object,
    filter: Object,
    canTransfer: Boolean,
    addDisabled: Boolean,
  },
  data() {
    return {
      items: [],
      total: 0,
      model: {},
      formerVisible: false,
      stockoutFormerVisible: false,
      scrapFormerVisible: false,
      wellFormerVisible: false,
      transferFormerVisible: false,
      editIndex: 0,
      loading: false,
      multiSelecting: false,
      selectedIDs: [],
    }
  },
  computed: {
    labelWidth() {
      return function (label) {
        const canvas = document.createElement('canvas')
        const context = canvas.getContext('2d')
        context.font = '14px Microsoft YaHei'
        const dimension = context.measureText(label)

        let width = dimension.width + 20
        if (width < 90) {
          width = 90
        }
        if (label == '螺杆规格') {
          width = 110
        }
        return width
      }
    },
  },
  created() {
    // this.getData()
    // this.filter.product_template_id = this.template.id
  },
  methods: {
    async getData() {
      this.selectedIDs = []
      this.$router.replace({
        query: { filter: JSON.stringify(this.filter) },
      })

      let data = this.clone(this.filter)
      data.page -= 1
      if (data.date && data.date.length == 2) {
        data.start_date = data.date[0]
        data.end_date = data.date[1]
      }
      this.loading = true
      let res = await productList(data)
      if (res.status == 0) {
        this.items = res.data.list
        this.total = res.data.count
        if (this.total == 0 && this.multiSelecting) {
          this.multiSelecting = false
        }
        this.loading = false
      }
    },
    handleSizeChange(size) {
      this.filter.size = size
      this.filter.page = 1
      this.getData()
    },
    async importCallback() {
      this.filter.page = 1
      this.getData()
    },
    assembleImportCallback(res) {
      this.$alert(`成功处理 ${res.data.success_count} 条数据！`)
      this.importCallback()
    },
    editItem(item, index) {
      if (!item) {
        this.editIndex = -1
        this.model = {
          product_template_id: this.template.id,
          code: '',
          name: this.template.name,
          group_name: this.filter.group_name,
          custom_params: this.template.custom_params || [],
          status: 1,
          remark: '',
          category: this.template.category,
          base_id: '',
          install_base_id: '',
        }
      } else {
        this.model = this.clone(item)
        this.model.custom_params = this.copyCustomParam(
          this.template.custom_params,
          item.custom_params,
        )
        this.editIndex = index
      }
      this.formerVisible = true
    },
    handleSelectionChange(items) {
      this.selectedIDs = items.map((item) => {
        return item.id
      })
    },
    itemStockOut(item, index) {
      this.model = {
        receive_base_id: '',
        id: item.id,
      }
      this.editIndex = index
      this.stockoutFormerVisible = true
    },
    async itemStockIn(item, index) {
      let res = await productStockIn({ id: item.id })
      if (res.code == 0) {
        this.$set(this.items, index, res.data)
        this.$emit('baseCheck')
      }
    },
    itemSendToWell(item, index) {
      this.model = {
        base_id: item.base_id,
        receive_well_id: '',
        id: item.id,
      }
      this.editIndex = index
      this.wellFormerVisible = true
    },
    async itemReceiveConfirm(item, index) {
      let res = await productReceiveComfirm({ id: item.id })
      if (res.code == 0) {
        this.$set(this.items, index, res.data)
        this.$emit('baseCheck')
      }
    },
    updatedCallback(data) {
      if (this.editIndex == -1) {
        this.items.unshift(data)
      } else {
        this.$set(this.items, this.editIndex, data)
      }
    },

    // clearTableSelected() {
    //   this.$refs.table.clearSelection()
    // },

    // 撤回
    async itemStockRecall(item, index) {
      let res = await productRecall({
        id: item.id,
      })
      if (res.code == 0) {
        this.$set(this.items, index, res.data)
        this.$notify.success('已撤回！')
      }
    },

    //拒收
    itemStockReject(item, index) {
      this.$prompt('拒收原因', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputType: 'textarea',
        inputValidator: (value) => {
          return !!value
        },
        inputErrorMessage: '拒收原因不能为空',
      }).then(async ({ value }) => {
        let res = await productReject({
          id: item.id,
          remark: value,
        })
        if (res.code == 0) {
          this.$set(this.items, index, res.data)
          this.$notify.success('已拒收！')
          this.$emit('baseCheck')
        }
      })
    },

    async handleScrap(item, index, status) {
      this.model = {
        category: 1,
        names: [item.code],
        ids: [item.id],
        attachments: [],
        remark: '',
        status: status,
      }
      this.scrapFormerVisible = true
      this.editIndex = index
    },

    scrapCallback() {
      this.getData()
      this.$notify.success('操作成功！')
    },

    async hanldeDelte(item, index) {
      let res = await productDelete(item.id)
      if (res.code == 0) {
        this.items.splice(index, 1)
      }
    },

    batchTransfer() {
      if (this.multiSelecting && this.selectedIDs.length == 0) {
        this.$message.error('当前勾选数量为 0，请重新勾选！')
        return
      }
      let options = []
      if (this.template.children_groups) {
        options = this.template.children_groups.split('、')
      }
      this.model = {
        name: this.template.name,
        options: options,
        filter: this.filter,
        total: this.multiSelecting ? this.selectedIDs.length : this.total,
        group_name: '',
        ids: this.multiSelecting ? this.selectedIDs : [],
      }
      this.transferFormerVisible = true
    },
  },
}
</script>

<style scoped>
.table-footer {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}
</style>